export default object => ({
  id: object.id,
  name: object.name,
  description: object.description,
});
